import { animate as animateList, stagger } from "vendor";
function ajaxinateCallBack() {
  let nextPage = parseInt(localStorage.getItem("pageLoaded"));
  let currentProductsPage = nextPage * 16;
  // console.log(currentProductsPage);
  let productCards = document.querySelectorAll('product-card[reveal-on-scroll="true"]');
  productCards.forEach((productCard, index) => {
    if (index > currentProductsPage) {
      animateList(
        productCard,
        {
          opacity: [0, 1],
          transform: ["translateY(20px)", "translateY(0)"],
        },
        {
          duration: 0.2,
          easing: "ease-in-out",
          delay: stagger(0.05, { start: 0.4, easing: "ease-out" }),
        }
      );
    }
  });

  nextPage = nextPage + 1
  localStorage.setItem("pageLoaded", nextPage);

  if (document.querySelectorAll('product-card[reveal-on-scroll="true"]').length > 26) {
    document.querySelector('.grid-callout-card-3').classList.remove('hidden');
  }
  if (document.querySelectorAll('product-card[reveal-on-scroll="true"]').length > 31) {
    document.querySelector('.grid-callout-card-4').classList.remove('hidden');
  }
}
var endlessScroll = new Ajaxinate({
  container: "[data-load-more--grid]",
  pagination: "[data-load-infinite]",
  loadingText: " ",
  callback: ajaxinateCallBack,
});
